import { convertArrayToObject } from "Services/Entity/helper";
import { getActionType } from "Store/Shared/Actions/Helpers"
import ACTIONS from "./ActionTypes"

const initialState = {
    _isFetching: true,
    _forceFetch: true,
    ids: [],
    entities: {},
    byName: {}
}

const settingsEntityReducer = (
    state = initialState,
    { payload, type }: any
) => {
    switch (type) {
        case getActionType(ACTIONS.FETCH_ENTITIES).REQUEST: {
            return {
                ...state,
                _isFetching: true,
                _forceFetch: false
            }
        }

        case getActionType(ACTIONS.FETCH_ENTITIES).SUCCESS: {
            const { data } = payload;
            const ids: any = data.sort((a, b) => (a?.name < b?.name) ? -1 : (a?.name > b?.name) ? 1 : 0).map(({id}) => (id));
            const entities: any = convertArrayToObject(data, 'id');

            const byName: any = data.reduce(
                (acc, curr) =>
                    acc = {
                        ...acc,
                        [curr.name]: curr.id
                    }
                , {}
            );
            
            return {
                ...state,
                _isFetching: false,
                ids,
                entities,
                byName
            }
        }

        case getActionType(ACTIONS.PATCH_ENTITY).REQUEST: {
            return {
                ...state,
                _isPatching: true
            }
        }

        case getActionType(ACTIONS.PATCH_ENTITY).SUCCESS: {
            const { data } = payload;
            return {
                ...state,
                _isPatching: false,
                entities: {
                    ...state.entities,
                    [data.id]: data
                }
            }
        }

        default:
            return state;
    }
}

export default settingsEntityReducer;